import { Check, X } from "lucide-react";
import { QUALIFY_NO, QUALIFY_YES } from "../../data/content";
import { CtaButton, Eyebrow, Reveal } from "./Primitives";

export const Qualify = () => (
  <section data-testid="qualification-section" className="border-y border-ink/10 bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow>Selective by design</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl">Performance pricing <span className="font-serif font-normal italic text-cobalt-700">isn't for everyone.</span></h2>
        <p className="mt-6 text-base leading-relaxed text-ink/70 sm:text-lg">We invest resources before seeing the upside, so Revenue Partner clients must qualify.</p>
      </Reveal>
      <div className="mt-14 grid gap-5 lg:grid-cols-2">
        <Reveal className="h-full">
          <div data-testid="qualify-yes-list" className="h-full rounded-[28px] border border-ink/10 bg-paper p-7 sm:p-9">
            <h3 className="font-display text-2xl font-bold text-ink">You're a strong fit if you have</h3>
            <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2">
              {QUALIFY_YES.map((q) => (
                <li key={q} className="flex items-start gap-3 text-[15px] text-ink/80"><span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-emerald-600"><Check className="h-3 w-3 text-white" strokeWidth={3} /></span>{q}</li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="h-full">
          <div data-testid="qualify-no-list" className="h-full rounded-[28px] border border-ink/10 p-7 sm:p-9">
            <h3 className="font-display text-2xl font-bold text-ink">Revenue Partnership probably isn't right if</h3>
            <ul className="mt-6 space-y-3">
              {QUALIFY_NO.map((q) => (
                <li key={q} className="flex items-start gap-3 text-[15px] text-ink/80"><span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full border border-red-300 bg-red-50"><X className="h-3 w-3 text-red-600" strokeWidth={3} /></span>{q}</li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
      <Reveal>
        <div className="mt-5 flex flex-col items-start justify-between gap-8 rounded-[28px] bg-cobalt-700 p-7 text-white sm:p-10 lg:flex-row lg:items-center">
          <div className="max-w-2xl">
            <p className="text-[13px] font-semibold uppercase tracking-[0.2em] text-cobalt-100">Think your company qualifies?</p>
            <h3 className="mt-3 font-display text-3xl font-bold sm:text-4xl">Let's find out.</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/85">We'll look at your offer, ACV, sales cycle, current pipeline, close rate, and target market to determine whether Coenzio's Revenue Partner model makes economic sense for both sides.</p>
            <p className="mt-4 text-[13px] font-medium text-white/80">15–30 minute fit call · No pitch deck marathon · No obligation</p>
          </div>
          <CtaButton testId="qualify-cta" variant="light">Apply for Revenue Partnership</CtaButton>
        </div>
      </Reveal>
    </div>
  </section>
);
